import { useTimeTransform } from '@hooks/useTimeTransform';
import { useUserTimeUnits } from '@hooks/useUserTimeUnits';
import { PetStatisticsModel } from '@models/Device';
import { getSingleDuration } from '@utils/date';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import useTotalConsumption from './useTotalConsumption';

export function useSummaryMovementCard(data: PetStatisticsModel['movement']) {
  const { t } = useTranslation();
  const { timeToFormat, convertDateToTime } = useTimeTransform();
  const userTimeFormat = useUserTimeUnits();

  const onlySeconds = useMemo(() => {
    if (typeof data?.time_outside === 'string') {
      const chunks = data.time_outside.split(':').map((item) => +item);
      return chunks.length === 3 ? !chunks[0] && !chunks[1] && chunks[2] : undefined;
    }
    return undefined;
  }, [data?.time_outside]);

  const outside = useTotalConsumption(onlySeconds || data?.time_outside || 0);

  const entered = useMemo(() => {
    return data?.last_entry ? timeToFormat(convertDateToTime(data.last_entry), userTimeFormat) : '';
  }, [data, userTimeFormat]);

  const timeAgo = useMemo(() => {
    return data?.last_entry ? getSingleDuration(data.last_entry, true) : '-';
  }, [data]);

  return {
    title: t('last_entered'),
    timeAgo,
    time: entered,
    leftLabel: outside,
    leftValue: t('time_outside'),
    rightLabel: data?.entries || 0,
    rightValue: t('entries'),
  };
}
